<template>
  <!-- 日期格式
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="日期格式"> 
      <el-select class="setting-date-format" v-model="dateFormat">
        <el-option value="yyyy-MM-dd" label="yyyy-MM-dd"></el-option>
        <el-option value="yyyy/MM/dd" label="yyyy/MM/dd"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 日期格式
     *  @description 将 dateFormat 字段映射到当前 dateFormat 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      dateFormat: { 
        parent: i => i.baseOption,
        attr: "dateFormat" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingDateFormat.vue